import * as emailConfigConstants from './actionTypes';
import {config} from '../../config/config';
import request from '../../components/Helper/Request';

const userDetails = JSON.parse(window.sessionStorage.getItem("userInfo"));

export const getEmailConfigList = (limit,page) => {
    return (dispatch) => {
      dispatch({
        type: emailConfigConstants.FETCH_EMAIL_CONFIG_LIST
      });

      request({
          method: 'get',
          url:`${config.API_URL}/api/email-configurations`,   
          params: {
              limit,
              page,
              sortOrder : "desc",
              sortBy : "modifiedTime"
          }
      })
        .then((response) => { 
          dispatch({
            type: emailConfigConstants.FETCH_EMAIL_CONFIG_LIST_SUCCESS,
            payload: response
          });
        })
        .catch((error) => {
          dispatch({
            type: emailConfigConstants.FETCH_EMAIL_CONFIG_LIST_FAILURE,
            payload:error
          });
        })
    }
}

export const getEmailConfigDetail = (emailConfigCode) => {
      return async (dispatch) => {
        try {
          dispatch({
            type: emailConfigConstants.FETCH_EMAIL_CONFIG_DETAIL
          });

          const emailConfigDetails = await request({
              method: 'get',
              url:`${config.API_URL}/api/email-configurations/${emailConfigCode}`          
          })
          const [headerDetails, footerDetails] = await Promise.all([
            request({
                method: 'get',
                url:`${config.API_URL}/api/email-section-configurations/${emailConfigDetails.headerConfigurationCode}`            
            }),
            request({
                method: 'get',
                url:`${config.API_URL}/api/email-section-configurations/${emailConfigDetails.footerConfigurationCode}`            
            })
          ]);
          dispatch({
            type: emailConfigConstants.FETCH_EMAIL_CONFIG_DETAIL_SUCCESS,
            payload: { ...emailConfigDetails, headerDetails, footerDetails }
          });
        }
        catch(error) {
          dispatch({
            type: emailConfigConstants.FETCH_EMAIL_CONFIG_DETAIL_FAILURE,
            payload:error
          });
        }
        return null;
    }
  
}

export const createEmailConfig =(emailConfigData) =>{

    const data = {
      ...emailConfigData,  
      createdBy: userDetails?.emailId,
      modifiedBy: userDetails?.emailId
    }; 
    return (dispatch) => {
    dispatch({
        type: emailConfigConstants.CREATE_EMAIL_CONFIG
    });

    request({
        method: 'post',
        url:`${config.API_URL}/api/email-configurations`,   
        data
    })
    .then((response) => {
        dispatch({
        type: emailConfigConstants.CREATE_EMAIL_CONFIG_SUCCESS,
        payload: response
        });
    }).catch((error) => {
        dispatch({
        type: emailConfigConstants.CREATE_EMAIL_CONFIG_FAILURE,
        payload:error?.response?.data
        });
    });
    }
}

export const editEmailConfig =(emailConfigData) =>{
        
  const data = {
    ...emailConfigData,
    modifiedBy: userDetails?.emailId
  }; 

  return (dispatch) => {
  dispatch({
      type: emailConfigConstants.EDIT_EMAIL_CONFIG
  });

  request({
      method: 'put',
      url:`${config.API_URL}/api/email-configurations/${data.code}`,
      data
  })
  .then((response) => {
      dispatch({
      type: emailConfigConstants.EDIT_EMAIL_CONFIG_SUCCESS,
      payload: response
      });
  }).catch((error) => {

      dispatch({
      type: emailConfigConstants.EDIT_EMAIL_CONFIG_FAILURE,
      payload:error?.response?.data
      });
  });
  }
}

export const deleteEmailConfig =(emailConfigData) =>{
        
  const data = {
    ...emailConfigData,
    modifiedBy: emailConfigData?.modifiedBy
  }; 

  return (dispatch) => {
  dispatch({
      type: emailConfigConstants.DELETE_EMAIL_CONFIG
  });

  request({
      method: 'delete',
      url:`${config.API_URL}/api/email-configurations/${data.code}`
  })
  .then(() => {
      dispatch({
      type: emailConfigConstants.DELETE_EMAIL_CONFIG_SUCCESS,
      payload: {status: 1}
      });
  }).catch(() => {
      dispatch({
      type: emailConfigConstants.DELETE_EMAIL_CONFIG_FAILURE,
      payload:{status: 0}
      });
  });
  }
}

export const resetEditEmailConfigData = () => {
return (dispatch) => {
  dispatch({
      type: emailConfigConstants.RESET_EDIT_EMAIL_CONFIG_STATE
  });  
  }
}

export const resetCreateEmailConfigData = () => {
return (dispatch) => {
  dispatch({
      type: emailConfigConstants.RESET_CREATE_EMAIL_CONFIG_STATE
  });  
  }
}